// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDyI8cxyvZ-B4sxvFsGqFTGQY2aYpWk6zw",
  authDomain: "matches-blooper.firebaseapp.com",
  projectId: "matches-blooper",
  storageBucket: "matches-blooper.firebasestorage.app",
  messagingSenderId: "850864662950",
  appId: "1:850864662950:web:cee291a87d6b10a755c767",
  measurementId: "G-TR7VQQY9L4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
// const analytics = getAnalytics(app);